<template>
    <div ref="backgroundContainer" class="auth-background min-h-screen">
        <!-- Video Background Layer -->
        <video
            v-if="hasVideoBackground && !useStaticFallback"
            ref="videoBg"
            class="video-background"
            autoplay
            loop
            muted
            playsinline
            :poster="fallbackImage"
            crossorigin="anonymous"
            @loadeddata="onVideoLoaded"
            @error="onVideoError"
        >
            <source v-if="mp4Source" :src="mp4Source" type="video/mp4">
            <source v-if="webmSource" :src="webmSource" type="video/webm">
        </video>

        <!-- Fallback Static Background -->
        <div
            v-if="!hasVideoBackground || useStaticFallback"
            :style="{backgroundImage: 'url(' + $store.state.settings.background + ')'}"
            class="static-background bg-cover bg-center"
        ></div>

        <!-- Overlay for readability -->
        <div class="bg-overlay"></div>

        <!-- Content Container -->
        <div class="container mx-auto">
            <div class="h-full min-h-screen flex items-center justify-center">
                <div class="w-full max-w-xl">
                    <div class="login-card">
                        <router-view/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "auth",
    data() {
        return {
            useStaticFallback: false,
            connectionChecked: false
        }
    },
    computed: {
        hasVideoBackground() {
            // Temporary hardcoded for testing
            return true;
            const settings = this.$store.state.settings;
            return !!(settings.background_video_mp4 ||
                     settings.background_video_webm ||
                     settings.background_video_url);
        },
        mp4Source() {
            // Temporary hardcoded for testing
            return 'https://moon.lspgatensi.id/files/gkk-asset/background-video.mp4';
            const url = this.$store.state.settings.background_video_url;
            const file = this.$store.state.settings.background_video_mp4;
            return url || file;
        },
        webmSource() {
            return this.$store.state.settings.background_video_webm;
        },
        fallbackImage() {
            return this.$store.state.settings.background;
        }
    },
    metaInfo() {
        return {
            titleTemplate: '%s - ' + this.$store.state.settings.name
        }
    },
    mounted() {
        this.checkConnectionSpeed();
        this.logVideoStatus();
    },
    methods: {
        checkConnectionSpeed() {
            // Use Navigator Connection API for network detection
            if (typeof navigator !== 'undefined' && 'connection' in navigator) {
                const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
                if (conn) {
                    const effectiveType = conn.effectiveType;
                    // Use static image on slow connections
                    if (effectiveType === 'slow-2g' || effectiveType === '2g') {
                        this.useStaticFallback = true;
                    }
                }
            }
            this.connectionChecked = true;
        },
        logVideoStatus() {
            console.log('Video Background Status:');
            console.log('hasVideoBackground:', this.hasVideoBackground);
            console.log('mp4Source:', this.mp4Source);
            console.log('webmSource:', this.webmSource);
            console.log('useStaticFallback:', this.useStaticFallback);
        },
        onVideoLoaded() {
            console.log('Video loaded successfully!');
            this.$nextTick(() => {
                if (this.$refs.videoBg) {
                    this.$refs.videoBg.play().catch(e => {
                        console.log('Video play error:', e);
                        this.useStaticFallback = true;
                    });
                }
            });
        },
        onVideoError(e) {
            console.log('Video load error:', e);
            this.useStaticFallback = true;
        }
    }
}
</script>

<style scoped>
.auth-background {
    position: relative;
}

.video-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
}

.static-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
}

.bg-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1;
}

.login-card {
    position: relative;
    z-index: 2;
    background: white;
    border-radius: 1rem;
    padding: 1rem 2rem 2rem 2rem;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    margin: 2rem;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>
